// extracted by mini-css-extract-plugin
module.exports = {"game-container":"styles_game-container__3QHho","title-wrapper":"styles_title-wrapper__29lHc","text":"styles_text__1WPzZ"};